import { render, staticRenderFns } from "./UploadArquivo.vue?vue&type=template&id=9da12236&scoped=true&"
import script from "./UploadArquivo.vue?vue&type=script&lang=js&"
export * from "./UploadArquivo.vue?vue&type=script&lang=js&"
import style0 from "./UploadArquivo.vue?vue&type=style&index=0&id=9da12236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da12236",
  null
  
)

export default component.exports